/* ALOURA — patch CRO sécurisé — 10 sept 2026 */
(function () {
  function discountUrl() {
    var back = window.location.pathname + window.location.search;
    return '/discount/ALOURA10?redirect=' + encodeURIComponent(back);
  }

  function initProductPromo() {
    var promo = document.querySelector('body.template-product .lp5__promo');
    if (!promo || promo.dataset.alouraAutoDiscount === 'true') return;

    promo.dataset.alouraAutoDiscount = 'true';
    promo.innerHTML = '';

    var icon = document.createElement('span');
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '%';

    var message = document.createElement('strong');
    message.textContent = '−10 % sur votre commande';

    var apply = document.createElement('a');
    apply.className = 'lp5__promo-apply';
    apply.href = discountUrl();
    apply.textContent = 'Appliquer −10 % maintenant';
    apply.setAttribute('aria-label', 'Appliquer le code ALOURA10 et revenir à cette fiche produit');

    var note = document.createElement('small');
    note.className = 'aloura-promo-note';
    note.textContent = 'Code ALOURA10';

    promo.appendChild(icon);
    promo.appendChild(message);
    promo.appendChild(apply);
    promo.appendChild(note);
  }

  function initHomePromo() {
    var oldButton = document.querySelector('body.template-index .an-offer [data-copy-code="ALOURA10"]');
    if (!oldButton) return;

    var apply = document.createElement('a');
    apply.className = 'an-offer__code an-offer__apply';
    apply.href = discountUrl();
    apply.setAttribute('aria-label', 'Appliquer le code promo ALOURA10');

    var code = document.createElement('b');
    code.textContent = 'ALOURA10';
    var label = document.createElement('small');
    label.textContent = 'Appliquer −10 %';
    apply.appendChild(code);
    apply.appendChild(label);
    oldButton.replaceWith(apply);

    var offer = apply.closest('.an-offer__inner');
    if (offer) {
      var paragraph = offer.querySelector(':scope > p');
      if (paragraph) {
        paragraph.textContent = 'Un seul code sur tout le site, valable une fois par client. Cliquez sur ALOURA10 pour appliquer automatiquement la remise. Livraison offerte en France et retours sous 30 jours.';
      }
    }
  }

  function init() {
    initProductPromo();
    initHomePromo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
